
import { useState } from 'react';

export default function HeroSection() {
  const [isVideoPlaying, setIsVideoPlaying] = useState(false);

  const scrollToDiagnostic = () => {
    const element = document.getElementById('diagnostico');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openWhatsApp = () => {
    const phoneNumber = '551123746167';
    const message = encodeURIComponent('Olá! Vim pelo site da M4 Digital e gostaria de mais informações sobre os serviços.');
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-slate-900 via-orange-900 to-red-900" id="inicio">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-20"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Modern%20digital%20technology%20background%20with%20AI%20neural%20networks%2C%20data%20visualization%2C%20holographic%20interfaces%2C%20vibrant%20orange%20and%20red%20gradients%2C%20minimalist%20tech%20aesthetic%2C%20professional%20business%20environment%2C%20warm%20orange%20lighting&width=1920&height=1080&seq=hero-bg-orange&orientation=landscape')`
        }}
      />
      
      {/* Gradient Overlay */}
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/90 to-transparent" />
      
      <div className="container relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-white space-y-8">
            <div className="space-y-4">
              <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight">
                Aumente Suas Vendas
                <span className="block gradient-text-orange">com Inteligência Comercial</span>
                e IA Aplicada
              </h1>
              
              <p className="text-xl lg:text-2xl text-gray-300 leading-relaxed max-w-2xl">
                Estruturamos seu tráfego estratégico, funil, CRM e automações com IA para fechar mais vendas com previsibilidade.
              </p>
            </div>
            
            {/* Stats */}
            <div className="flex flex-wrap gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-orange-400">+1.200</div>
                <div className="text-gray-400">Empresas Aceleradas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-red-400">+300%</div>
                <div className="text-gray-400">Aumento Médio em Vendas</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-yellow-400">24h</div>
                <div className="text-gray-400">Implementação Rápida</div>
              </div>
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4">
              <button 
                onClick={scrollToDiagnostic}
                className="btn-primary-orange text-lg cursor-pointer"
              >
                <i className="ri-calendar-line mr-2"></i>
                Agendar Diagnóstico Gratuito
              </button>
              <button 
                className="btn-secondary-orange text-lg"
                onClick={() => setIsVideoPlaying(true)}
              >
                <i className="ri-play-circle-line mr-2"></i>
                Ver Como Funciona
              </button>
            </div>
            
            {/* Trust Indicators */}
            <div className="flex items-center gap-6 pt-4">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line text-green-400 text-xl"></i>
                <span className="text-gray-300">100% Seguro</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line text-orange-400 text-xl"></i>
                <span className="text-gray-300">Resultados em 30 dias</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-award-line text-red-400 text-xl"></i>
                <span className="text-gray-300">Garantia de Satisfação</span>
              </div>
            </div>
          </div>
          
          {/* Right Content - Interactive Demo */}
          <div className="relative">
            <div className="bg-white/10 backdrop-blur-lg rounded-2xl p-8 border border-white/20">
              <div className="space-y-6">
                <div className="text-center">
                  <h3 className="text-2xl font-bold text-white mb-4">
                    Diagnóstico Gratuito
                  </h3>
                  <p className="text-gray-300">
                    Descubra o potencial de crescimento do seu negócio
                  </p>
                </div>
                
                <div className="space-y-4">
                  <div className="flex items-center gap-3 text-white">
                    <div className="w-8 h-8 bg-orange-510 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-sm"></i>
                    </div>
                    <span>Análise completa do seu funil de vendas</span>
                  </div>
                  <div className="flex items-center gap-3 text-white">
                    <div className="w-8 h-8 bg-red-500 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-sm"></i>
                    </div>
                    <span>Identificação de oportunidades de automação</span>
                  </div>
                  <div className="flex items-center gap-3 text-white">
                    <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                      <i className="ri-check-line text-sm"></i>
                    </div>
                    <span>Estratégia personalizada para seu negócio</span>
                  </div>
                </div>
                
                <button 
                  onClick={scrollToDiagnostic}
                  className="w-full btn-primary-orange cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  Agendar Consultoria Gratuita
                </button>
              </div>
            </div>
            
            {/* Floating Elements */}
            <div className="absolute -top-4 -right-4 w-20 h-20 bg-orange-500/20 rounded-full blur-xl animate-pulse"></div>
            <div className="absolute -bottom-4 -left-4 w-16 h-16 bg-red-500/20 rounded-full blur-xl animate-pulse delay-1000"></div>
          </div>
        </div>
      </div>
      
      {/* Video Modal */}
      {isVideoPlaying && (
        <div className="fixed inset-0 bg-black/80 z-50 flex items-center justify-center p-4">
          <div className="relative max-w-4xl w-full">
            <button 
              onClick={() => setIsVideoPlaying(false)}
              className="absolute -top-12 right-0 text-white text-2xl hover:text-gray-300 cursor-pointer"
            >
              <i className="ri-close-line"></i>
            </button>
            <div className="bg-black rounded-lg overflow-hidden">
              <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
                <iframe
                  className="absolute top-0 left-0 w-full h-full"
                  src="https://www.youtube.com/embed/bFAVLErA-oI?autoplay=1&rel=0&modestbranding=1"
                  title="Como a M4 Digital Funciona"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="p-6 bg-gray-900 text-center">
                <h3 className="text-2xl font-bold text-white mb-4">
                  Veja como a M4 Digital pode transformar seus resultados
                </h3>
                <button 
                  onClick={scrollToDiagnostic}
                  className="btn-primary-orange cursor-pointer"
                >
                  <i className="ri-calendar-line mr-2"></i>
                  Agendar Diagnóstico Gratuito
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
